import styled from 'styled-components';
import {mobileMedia} from '../../../globalVariables/GlobalVariables';
import {expanded} from '../expandedClass.css';

export const container = styled(expanded)`
${mobileMedia}{
    padding-bottom: 10px;
    }
`;
